import { h } from "../../core/dom.js";

export function accordion(blocks, { openId = null } = {}) {
  const sections = [];
  const element = h("div", { class: "accordion" });

  const setOpen = (target, open) => {
    target.panel.classList.toggle("hidden", !open);
    target.head.setAttribute("aria-expanded", String(open));
    target.head.classList.toggle("open", open);
  };

  const toggle = (target) => {
    const open = target.panel.classList.contains("hidden");
    for (const section of sections) setOpen(section, section === target && open);
  };

  for (const block of blocks.filter(Boolean)) {
    const panel = h("div", { class: "accordion-panel hidden" }, block.content);
    const head = h("button", { class: "accordion-head", type: "button", "aria-expanded": "false" },
      h("span", { class: "accordion-title" }, block.icon ? `${block.icon} ` : "", block.title, block.badge || null),
      h("span", { class: "accordion-mark", "aria-hidden": "true" }, "▾"));
    const section = { id: block.id, head, panel };
    head.addEventListener("click", () => toggle(section));
    sections.push(section);
    element.append(h("section", { class: "accordion-block" }, head, panel));
  }

  const initial = sections.find((section) => section.id === openId);
  if (initial) setOpen(initial, true);

  return {
    element,
    get openId() {
      return sections.find((section) => !section.panel.classList.contains("hidden"))?.id || null;
    },
    open(id) {
      const target = sections.find((section) => section.id === id);
      if (!target) return null;
      for (const section of sections) setOpen(section, section === target);
      return target.id;
    }
  };
}
